import { FilterParams } from '@synergy/models';
import { PoolCurrencySymbol, PoolNumberTextfield } from '@synergy/components-next';
import { ReactElement, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { FilterLine } from '../styled-components/filter-line';
import { FilterRangeContainer } from '../styled-components/filter-range-container';
import { currencySelector } from '../../../store/configuration-selectors';
import { useAppSelector } from '../../../../store/store';
import { useFilter } from '../filter-context';

export const FilterPrice = (): ReactElement => {
    const { filter, updateFilter } = useFilter();
    const intl = useIntl();
    const maxPriceRef = useRef<HTMLInputElement>();
    const currency = useAppSelector(currencySelector);

    const minPrice = filter.get(FilterParams.MinPrice) ?? undefined;
    const maxPrice = filter.get(FilterParams.MaxPrice) ?? undefined;
    const [minPriceState, setMinPriceState] = useState(minPrice);
    const [maxPriceState, setMaxPriceState] = useState(maxPrice);
    const [initialMinPrice, setInitialMinPrice] = useState<string | undefined>(undefined);
    const [initialMaxPrice, setInitialMaxPrice] = useState<string | undefined>(undefined);

    const handleChangeMinOnBlur = (): void => {
        if (minPriceState !== initialMinPrice) {
            filter.delete(FilterParams.MinPrice);
            if (minPriceState) {
                filter.set(FilterParams.MinPrice, minPriceState);
            }
            updateFilter(filter);
            setInitialMinPrice(minPriceState);
        }
    };

    const handleChangeMaxOnBlur = (): void => {
        if (maxPriceState !== initialMaxPrice) {
            filter.delete(FilterParams.MaxPrice);
            if (maxPriceState) {
                filter.set(FilterParams.MaxPrice, maxPriceState);
            }
            updateFilter(filter);
            setInitialMaxPrice(maxPriceState);
        }
    };

    return (
        <FilterRangeContainer>
            <PoolNumberTextfield
                label={intl.formatMessage({
                    id: 'app.filter.price.from',
                })}
                value={minPriceState}
                onBlur={handleChangeMinOnBlur}
                onChange={e => setMinPriceState(e.target.value)}
                endAdornment={<PoolCurrencySymbol currency={currency} />}
                sx={{
                    minWidth: theme => theme.spacing(14.25),
                    width: theme => theme.spacing(14.25),
                    height: theme => theme.spacing(7),
                }}
                noFractionalNumbers={true}
                autoFocus={true}
                noNegativeNumbers={true}
            />

            <FilterLine />

            <PoolNumberTextfield
                inputRef={maxPriceRef}
                label={intl.formatMessage({
                    id: 'app.filter.price.to',
                })}
                value={maxPriceState}
                onBlur={handleChangeMaxOnBlur}
                onChange={e => setMaxPriceState(e.target.value)}
                endAdornment={<PoolCurrencySymbol currency={currency} />}
                sx={{
                    minWidth: theme => theme.spacing(14.25),
                    width: theme => theme.spacing(14.25),
                    height: theme => theme.spacing(7),
                }}
                noFractionalNumbers={true}
                noNegativeNumbers={true}
            />
        </FilterRangeContainer>
    );
};
